var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_3368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6617 5.88435C20.5528 5.44931 20.331 5.05071 20.0188 4.7288C19.7065 4.4069 19.3149 4.1731 18.8833 4.05102C17.3067 3.66602 11 3.66602 11 3.66602C11 3.66602 4.69333 3.66602 3.11666 4.08768C2.68514 4.20977 2.29347 4.44357 1.98123 4.76547C1.66898 5.08737 1.44722 5.48597 1.33833 5.92102C1.04978 7.52111 0.908628 9.1443 0.916662 10.7702C0.906376 12.4083 1.04753 14.0439 1.33833 15.656C1.45837 16.0775 1.68511 16.461 1.99663 16.7693C2.30814 17.0776 2.69391 17.3003 3.11666 17.416C4.69333 17.8377 11 17.8377 11 17.8377C11 17.8377 17.3067 17.8377 18.8833 17.416C19.3149 17.2939 19.7065 17.0601 20.0188 16.7382C20.331 16.4163 20.5528 16.0177 20.6617 15.5827C20.948 13.9946 21.0891 12.3838 21.0833 10.7702C21.0936 9.13206 20.9525 7.49649 20.6617 5.88435V5.88435Z",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 13.7684L14.2083 10.7709L8.9375 7.77344V13.7684Z",
    stroke: "#4F4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_3368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5a8ced810c1fb9c2643cf68b27433ba3.svg";
export { ForwardRef as ReactComponent };